module.exports = __webpack_public_path__ + "4d28a21cd906378a4db2b0ad8407e412.jpg";